import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ChatRequest, ChatResponse } from './chat-request.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QueryService {
  private apiUrl = environment.apiLocation;

  constructor(private http: HttpClient) {}

  /**
   * Send a chat query to the API
   */
  sendQuery(request: ChatRequest): Promise<ChatResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const payload: ChatRequest = {
      query: request.query,
      session_id: request.session_id
    };

    // Keep payload aligned with prior direct UI call shape:
    // { query, session_id }
    // if (typeof request.stream === 'boolean') {
    //   payload.stream = request.stream;
    // }

    return this.http.post<ChatResponse>(
      `${this.apiUrl}/AIChat/Query`,
      payload,
      { headers }
    ).pipe(
      retry(2), // Retry up to 2 times on failure
      catchError(this.handleError)
    ).toPromise() as Promise<ChatResponse>;
  }

  /**
   * Get the status of the query service
   */
  //getStatus(): Promise<QueryStatus> {
  //  return this.http.get<QueryStatus>(
  //    `${this.apiUrl}/api/chat/status`
  //  ).pipe(
  //    catchError(this.handleError)
  //  ).toPromise() as Promise<QueryStatus>;
  //}

  /**
   * Stream chat response (if Server-Sent Events are implemented)
   */
  streamQuery(request: ChatRequest): Observable<ChatResponse> {
    // Implementation for streaming if needed
    // This would use EventSource or WebSocket
    throw new Error('Streaming not yet implemented');
  }

  /**
   * Handle HTTP errors
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred';
    
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      switch (error.status) {
        case 400:
          errorMessage = 'Invalid request. Please check your query.';
          break;
        case 401:
          errorMessage = 'Unauthorized. Please log in.';
          break;
        case 404:
          errorMessage = 'Service not found. Please check the API URL.';
          break;
        case 500:
          errorMessage = 'Server error. Please try again later.';
          break;
        default:
          errorMessage = `Error: ${error.status} - ${error.message}`;
      }
    }
    
    console.error('QueryService error:', errorMessage, error);
    return throwError(() => new Error(errorMessage));
  }
}